import { render, staticRenderFns } from "./Qft.vue?vue&type=template&id=571e3935&scoped=true"
import script from "./Qft.vue?vue&type=script&lang=js"
export * from "./Qft.vue?vue&type=script&lang=js"
import style0 from "./Qft.vue?vue&type=style&index=0&id=571e3935&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571e3935",
  null
  
)

export default component.exports